// extracted by mini-css-extract-plugin
module.exports = {"alternateTitle":"ArtistAlternateTitles-alternateTitle-3oq8Y"};